import { createTheme, MantineColorsTuple } from '@mantine/core'

// Medieval color palette - Golden theme
const golden: MantineColorsTuple = [
  '#fef9e7',
  '#fdf4d0',
  '#fcefb9',
  '#fbeaa2',
  '#fae58b',
  '#f7ca02', // Base color
  '#e5b802',
  '#d3a602',
  '#c19402',
  '#af8202',
]

const parchment: MantineColorsTuple = [
  '#fdfcf9',
  '#f8f5ee',
  '#f0e9d9',
  '#e8ddc3',
  '#e1d3b0',
  '#dccba4',
  '#dac89f',
  '#c2b18a',
  '#ad9d7a',
  '#978867',
]

const medieval: MantineColorsTuple = [
  '#f7f6f3',
  '#e9e6de',
  '#d3ccba',
  '#bcb094',
  '#a89874',
  '#9c8960',
  '#968156',
  '#826f47',
  '#74623d',
  '#64542f',
]

export const theme = createTheme({
  colors: {
    golden,
    parchment,
    medieval,
  },
  primaryColor: 'golden',
  fontFamily: "'Crimson Text', Georgia, serif",
  headings: {
    fontFamily: "'Cinzel', serif",
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '3rem', lineHeight: '1.2' },
      h2: { fontSize: '2.25rem', lineHeight: '1.3' },
      h3: { fontSize: '1.75rem', lineHeight: '1.4' },
      h4: { fontSize: '1.5rem', lineHeight: '1.4' },
      h5: { fontSize: '1.25rem', lineHeight: '1.5' },
      h6: { fontSize: '1rem', lineHeight: '1.5' },
    },
  },
  fontSizes: {
    xs: '0.875rem',
    sm: '1rem',
    md: '1.125rem',
    lg: '1.25rem',
    xl: '1.5rem',
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  radius: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
  },
  shadows: {
    xs: '0 1px 3px rgba(68, 42, 30, 0.12)',
    sm: '0 2px 6px rgba(68, 42, 30, 0.16)',
    md: '0 4px 12px rgba(68, 42, 30, 0.2)',
    lg: '0 8px 24px rgba(68, 42, 30, 0.24)',
    xl: '0 16px 48px rgba(68, 42, 30, 0.28)',
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontFamily: "'Cinzel', serif",
          fontWeight: 600,
        },
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        shadow: 'md',
        padding: 'xl',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
        padding: 'lg',
      },
    },
    Title: {
      styles: {
        root: {
          color: 'var(--mantine-color-golden-7)',
        },
      },
    },
  },
})
